module.exports = __webpack_public_path__ + "img/wximg32.e1f857d4.png";